/* eslint-disable @next/next/no-html-link-for-pages */
import styles from "../styles/Home.module.css";
import { Box, Flex } from "@chakra-ui/react";
import SwiperCore, {
  Autoplay,
  Pagination,
  Navigation,
  EffectFade,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
const AsyncTypeahead = withAsync(Typeahead);
import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { Typeahead, withAsync } from "react-bootstrap-typeahead";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import AutoRankingSlide from "./autoranking";

export default function SearchHeader(props) {
  const router = useRouter();
  const { keyword } = router.query;
  const [inputKeyword, setInputKeyword] = useState(keyword);
  const [isLoading, setisLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const onChange = (e) => {
    setInputKeyword(e.target.value);
  };

  const _handleAutocomplete = (query) => {
    const enc_query = encodeURIComponent(query);
    setisLoading(true);
    setInputKeyword(query);
    fetch(
      process.env.SEARCH_API_URL +
        `/search?keyword=${enc_query}&type=autocomplete`
    )
      .then((resp) => resp.json())
      .then(({ data }) => {
        const options = data.hits.hits.map((i) => ({
          id: Number(i._id),
          login: i._source.it_name,
          it_name: i._source.it_name,
        }));
        setOptions(options);
        setisLoading(false);
      });
  };

  const onClick = async (e) => {
    e.preventDefault();
    if (!inputKeyword) {
      alert("검색어를 입력하세요");
    } else {
      window.location.href =
        "/search/lists?keyword=" +
        (inputKeyword.startsWith("%")
          ? inputKeyword
          : encodeURIComponent(inputKeyword));
    }
    return;
  };

  useEffect(() => {}, []);

  return (
    <Box className="header_search">
      <Box>
        {/* 🔧 Flex로 검색창 + 인기부품 나란히 배치 */}
        <Flex className="search_wrap">
          {/* 🔍 검색창 */}
          <Box flex="1">
            <AsyncTypeahead
              id="search-typeahead" // ✅ 이 한 줄로 경고 해결!
              className="search_box"
              isLoading={isLoading}
              size="lg"
              color="333"
              h="50px"
              minLength={3}
              labelKey="login"
              defaultInputValue={
                inputKeyword
                  ? inputKeyword.startsWith("%")
                    ? decodeURIComponent(inputKeyword)
                    : inputKeyword
                  : ""
              }
              value={keyword}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  if (event.target.value) {
                    event.preventDefault();
                    window.location.href =
                      "/search/lists?keyword=" +
                      encodeURIComponent(event.target.value);
                  } else {
                    alert("검색어를 입력하세요");
                  }
                  setInputKeyword("");
                }
              }}
              onChange={onChange}
              onSearch={_handleAutocomplete}
              options={options}
              placeholder="전자부품 번호(P/N)로 검색하세요!"
              renderMenuItemChildren={(option, props) => (
                <div
                  onClick={() => {
                    window.location.href =
                      "/search/lists?keyword=" +
                      encodeURIComponent(option.it_name);
                  }}
                >
                  <span>{option.it_name}</span>
                </div>
              )}
            >
              <span></span>
              <button onClick={onClick}>
                <FontAwesomeIcon
                  className="top-bar_search-input__search-icon"
                  icon={faSearch}
                />
              </button>
            </AsyncTypeahead>
          </Box>

          {/* ⭐ 인기부품 컴포넌트 */}
        </Flex>
        {/* <Box className="ranking_wrap">
          <Box position="relative">
            <AutoRankingSlide />
          </Box>
        </Box> */}
      </Box>
    </Box>
  );
}
